module.exports = __webpack_public_path__ + "static/assets/caec35551d9e53178bee24bbd190f8b6.png";